import React from 'react'
import { observer } from 'mobx-react'
import usePortManager from '../hooks/use-port-manager'

function getFrameRightStyle () {
  const portManager = usePortManager()

  const portWidth = portManager.getPortWidth()
  const portHeight = portManager.getPortHeight()

  const width = (7 / portWidth) * 100
  const height = 100 + (25 / portHeight) * 100
  const backgroundHeight = (30 / (portHeight + 25)) * 100

  const base_url = window.main_theme_objects.assets_url
  const backgroundImageSrc = base_url + 'port-images/frame/background_frame_right.png'

  return {
    backgroundImage: 'url(\'' + backgroundImageSrc + '\')',
    width: width + '%',
    height: height + '%',
    backgroundSize: '100% ' + backgroundHeight + '%'
  }
}

function getFrameLeftStyle () {
  const portManager = usePortManager()

  const portWidth = portManager.getPortWidth()
  const portHeight = portManager.getPortHeight()

  const width = (7 / portWidth) * 100
  const height = 100 + (25 / portHeight) * 100
  const backgroundHeight = (30 / (portHeight + 25)) * 100

  const base_url = window.main_theme_objects.assets_url
  const backgroundImageSrc = base_url + 'port-images/frame/background_frame_left.png'

  return {
    backgroundImage: 'url(\'' + backgroundImageSrc + '\')',
    width: width + '%',
    height: height + '%',
    backgroundSize: '100% ' + backgroundHeight + '%'
  }
}

function getFrameTopStyle () {
  const portManager = usePortManager()

  const portHeight = portManager.getPortHeight()

  const height = ((30 / portHeight) * 100)

  return {
    height: height + '%'
  }
}

function getFrameTopCenterStyle () {
  const base_url = window.main_theme_objects.assets_url
  const backgroundImageSrc = base_url + 'port-images/frame/frame_top_center.png'

  return {
    backgroundImage: 'url(\'' + backgroundImageSrc + '\')',
  }
}

function getFrameTopLeftStyle () {
  const portManager = usePortManager()

  const portWidth = portManager.getPortWidth()

  const width = (80 / portWidth) * 100
  const position = 100 - ((65 / portWidth) * 100)

  return {
    width: width + '%',
    right: position + '%'
  }
}

function getFrameTopRightStyle () {
  const portManager = usePortManager()

  const portWidth = portManager.getPortWidth()

  const width = (90 / portWidth) * 100
  const position = 100 - ((78 / portWidth) * 100)

  return {
    width: width + '%',
    left: position + '%'
  }
}

function getFrameSideTopLeftStyle () {
  const portManager = usePortManager()

  const portHeight = portManager.getPortHeight()
  const portWidth = portManager.getPortWidth()

  const width = ((portHeight - 50) / portWidth) * 100
  const position = (40 / portWidth) * 100

  return {
    width: width + '%',
    right: position + '%'
  }
}

function getFrameStyle () {
  const portManager = usePortManager()

  const [cssHeight, cssWidth] = portManager.getPortCSSHeightAndWidth()

  return {
    width: cssWidth + '%',
    height: cssHeight + '%',
  }
}

function getFrameSideBottomStyle () {
  const portManager = usePortManager()

  const portWidth = portManager.getPortWidth()
  const portHeight = portManager.getPortHeight()

  const width = (11 / portWidth) * 100
  const height = 100 - (30 / portHeight) * 100

  const base_url = window.main_theme_objects.assets_url
  const backgroundImageSrc = base_url + 'port-images/frame/frame_left_side_bottom.png'

  return {
    backgroundImage: 'url(\'' + backgroundImageSrc + '\')',
    width: width + '%',
    height: height + '%',
  }
}

function getFrameSideLeftStyle () {
  const portManager = usePortManager()

  const portWidth = portManager.getPortWidth()

  const frameLeftWidth = (7 / portWidth) * 100

  const [cssHeight, cssWidth] = portManager.getPortCSSHeightAndWidth()

  return {
    transform: 'translateY(-50%) translateX(' + (-100 - frameLeftWidth) + '%) rotateY(-90deg) translateX(-50%)',
    width: cssWidth + '%',
    height: cssHeight + '%',
  }
}

function getFrameSideRightStyle () {
  const portManager = usePortManager()

  const portWidth = portManager.getPortWidth()

  const frameLeftWidth = (7 / portWidth) * 100

  const [cssHeight, cssWidth] = portManager.getPortCSSHeightAndWidth()

  return {
    transform: 'translateY(-50%) translateX(' + frameLeftWidth + '%) rotateY(-90deg) translateX(-50%)',
    width: cssWidth + '%',
    height: cssHeight + '%',
  }
}

function Frame (props) {
  const baseURL = window.main_theme_objects.assets_url

  return (
    <React.Fragment>
      <div className={'frame_left_side_wrapper'} style={getFrameSideLeftStyle()}>
        <div className={'frame_side_bottom'} style={getFrameSideBottomStyle()}></div>
        <div className={'frame_side_top'} style={getFrameTopStyle()}>
          <img className={'frame_side_top_left'} src={baseURL + 'port-images/frame/frame_left_side_top.png'}
               style={getFrameSideTopLeftStyle()}/>
          <img className={'frame_side_top_right'} src={baseURL + 'port-images/frame/frame_left_side_middle.png'}/>
        </div>
      </div>
      <div className={'frame_right_side_wrapper'} style={getFrameSideRightStyle()}>
        <div className={'frame_side_top'} style={getFrameTopStyle()}>
          <img className={'frame_side_top_left'} src={baseURL + 'port-images/frame/frame_right_side_top.png'}
               style={getFrameSideTopLeftStyle()}/>
          <img className={'frame_side_top_right'} src={baseURL + 'port-images/frame/frame_right_side_middle.png'}/>
        </div>
      </div>
      <div className={'frame_wrapper'} style={getFrameStyle()}>
        <div className={'frame_left'} style={getFrameLeftStyle()}></div>
        <div className={'frame_right'} style={getFrameRightStyle()}></div>
        <div className={'frame_top'} style={getFrameTopStyle()}>
          <div className={'frame_top_center'} style={getFrameTopCenterStyle()}></div>
          <img className={'frame_top_left'} src={baseURL + 'port-images/frame/frame_top_left.png'}
               style={getFrameTopLeftStyle()}/>
          <img className={'frame_top_right'} src={baseURL + 'port-images/frame/frame_top_right.png'}
               style={getFrameTopRightStyle()}/>
        </div>
        {props.children}
      </div>
    </React.Fragment>
  )
}

export default observer(Frame)